import { createSlice, type PayloadAction } from '@reduxjs/toolkit';
import { getAuthProvider } from '@/auth/auth-provider';
import { sharedActions } from './shared-actions';

export const appStateSlice = createSlice({
  name: 'app-state',
  initialState: {
    authenticated: getAuthProvider().isAuthenticated,
    error: false,
    initialized: false,
    initializing: false,
  },
  reducers: {
    authChange: (state) => {
      return {
        ...state,
        authenticated: getAuthProvider().isAuthenticated,
      };
    },
    appStateLoadStarted: (state) => {
      return {
        ...state,
        error: false,
        initialized: false,
        initializing: true,
      };
    },
    appStateLoadError: (state, _action) => {
      return {
        ...state,
        error: true,
        initialized: false,
        initializing: false,
      };
    },
  },
  extraReducers: (builder) => {
    builder.addCase(sharedActions.appStateLoaded, (state) => {
      return {
        ...state,
        error: false,
        initialized: true,
        initializing: false,
      };
    });
    builder.addCase(sharedActions.userLoggedOutAction, (state) => {
      if (state.authenticated) {
        getAuthProvider().logout();

        return {
          error: false,
          authenticated: false,
          initialized: false,
          initializing: false,
        };
      }
      return state;
    });
  },
});

export default appStateSlice.reducer;
